
const app = {
	
	$win    : $(window),
	$doc    : $(document),
	$body   : $('body'),
	$header : $('.header-main')

}

export { app }